<template>
    <div>
        <b-icon v-if="iconType == 'b-icon'" :icon="iconValue" scale="2"></b-icon>
        <img :src="iconValue" v-else-if="iconType == 'img'" style="width: 100%"/>
    </div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String
        }
    },

    computed: {
        iconType() {
            const part = this.icon.split(':')

            return part[0]
        },

        iconValue() {
            return this.icon.replace(`${this.iconType}:`, '')
        }
    },
}
</script>